import { MouseEvent } from "react";
import classNames from "classnames";
import { DatasetStatusEnum } from "types";
import { useDispatch } from "react-redux";
import { setShowDatasetErrorModal } from "redux/Modals/actions";

import styles from "./style.module.scss";

/**
 * @deprecated this function is deprecated use useUserConfig hook instead
 */
const DeprecatedDatasetStatusButton = ({
  status,
  datasetId,
  errorMessage,
  buttonStyle,
}: DeprecatedDatasetStatusButtonTypes) => {
  const dispatch = useDispatch();

  const handleButtonStyle = () => {
    const lineHeight = buttonStyle?.lineHeight
      ? parseFloat(buttonStyle.lineHeight)
      : null;

    if (!lineHeight) return buttonStyle;

    const paddingV = lineHeight * 0.5;
    const paddingH = lineHeight;

    return {
      ...buttonStyle,
      padding: `${paddingV}px ${paddingH}px`,
      borderRadius: `${paddingV}px`,
    };
  };

  const fontSize = handleButtonStyle()?.fontSize || undefined;
  const dynamicStatusText =
    status === DatasetStatusEnum.FATAL_ERROR
      ? "FAILED"
      : status === DatasetStatusEnum.INITIALIZING
        ? "RESUME"
        : status;

  const isInProgress =
    status === DatasetStatusEnum.UPLOADING ||
    status === DatasetStatusEnum.INDEXING;
  const isFailed = status === DatasetStatusEnum.FATAL_ERROR;

  const statusButtonClassnames = classNames(styles.default, {
    [styles.indexing]: [
      DatasetStatusEnum.UPLOADING,
      DatasetStatusEnum.INDEXING,
      DatasetStatusEnum.ENRICHING,
      DatasetStatusEnum.UPDATING,
      "SAVING",
    ].includes(status),
    [styles.resume]: [
      DatasetStatusEnum.INITIALIZING,
      DatasetStatusEnum.NEW,
      DatasetStatusEnum.PENDING_INDEX,
    ].includes(status),
    [styles.ready]: status === DatasetStatusEnum.READY,
    [styles.failed]: isFailed,
  });

  const handleViewErrorClick = (event: MouseEvent) => {
    event.stopPropagation();

    dispatch(
      setShowDatasetErrorModal({
        datasetId,
        errorMessage,
      }),
    );
  };

  const spinnerStyles = fontSize
    ? { height: fontSize, width: fontSize }
    : undefined;

  const viewStatusStyles = fontSize ? { fontSize } : undefined;

  return (
    <div className={statusButtonClassnames} style={handleButtonStyle()}>
      {isInProgress && (
        <div className={styles.spinner} style={spinnerStyles}></div>
      )}
      {dynamicStatusText}
      {isInProgress && <span>...</span>}
      {isFailed && (
        <div
          style={viewStatusStyles}
          className={styles.viewStatus}
          onClick={handleViewErrorClick}
        >
          <span>VIEW</span>
        </div>
      )}
    </div>
  );
};
interface DeprecatedDatasetStatusButtonTypes {
  status: DatasetStatusEnum;
  datasetId: string;
  errorMessage: string;
  buttonStyle: any;
}

export default DeprecatedDatasetStatusButton;
